import BaseReducer from "../../utilities/BaseReducer";
import IAction from "../../models/IAction";
import RichiestaModel from "./models/RichiestaModel";
import ResponseEsitoModel from "stores/shared/models/ResponseEsitoModel";
import RichiestaDatiAnagraficiRequestModel from "./models/RichiestaDatiAnagraficiRequestModel";
import RichiestaAltriPrestitiRequestModel from "./models/RichiestaAltriPrestitiRequestModel";
import RichiestaDocumentoViewModel from "./models/RichiestaDocumentoViewModel";
import IRichiestaState from "./models/IRichiestaState";
import RichiestaAction from "./RichiestaAction";
import RichiestaDatiRedditoRequestModel from "./models/RichiestaDatiRedditoRequestModel";
import RichiestaDocumentiViewModel from "./models/RichiestaDocumentiViewModel";
import ResponseStatoModel from "../shared/models/ResponseStatoModel";
import StatoProcessoFirmaDigitale from "../../constants/StatoProcessoFirmaDigitale";
import CqsOnlineRichiestaSezioneDocumentiViewModel from "stores/cqsonline/models/CqsOnlineRichiestaSezioneDocumentiViewModel";
import CqsOnlineRichiestaDettaglioDocumentoViewModel from "stores/cqsonline/models/CqsOnlineRichiestaDettaglioDocumentoViewModel";
import CqsOnlineStatoProcessoDocumentiDaFirmare from "constants/CqsOnlineStatoProcessoDocumentiDaFirmare";
import CqsOnlineRichiestaInfoSezionePreventivoViewModel from "stores/cqsonline/models/CqsOnlineRichiestaInfoSezionePreventivoViewModel";
import RichiestaConcludiRequestModel from "./models/RichiestaConcludiRequestModel";
import NuovoImpegnoModel from "stores/preventivo/models/NuovoImpegnoModel";
import RichiestaAdeguataVerificaRequestModel from "./models/RichiestaAdeguataVerificaRequestModel";

export default class RichiestaReducer extends BaseReducer<IRichiestaState> {
    public readonly initialState: IRichiestaState = {
        corrente: new RichiestaModel({}),
        isRichiestaPresente: false,
        responseVerificaRichiesta: false,
        responseRichiesta: false,
        responseStepRichiesta: false,
        responseDatiAnagrafici: false,
        responseAdeguataVerifica: false,
        responseDatiReddito: false,
        responseAltriPrestiti: false,
        responseUploadDocumento: false,
        responseDownloadDocumento: false,
        responseDownloadPianoAmmortamento: false,
        responseAvviaProcessoFirmaDebole: false,
        responseAnnullaProcessoFirmaDebole: false,
        statoProcessoFirmaDebole: StatoProcessoFirmaDigitale.NonEsiste,
        responseAvviaProcessoFirmaForte: false,
        responseAnnullaProcessoFirmaForte: false,
        statoProcessoFirmaForte: StatoProcessoFirmaDigitale.NonEsiste,
        responseAvviaProcessoRiconoscimento: false,
        responseAnnullaProcessoRiconoscimento: false,
        statoProcessoRiconoscimento: StatoProcessoFirmaDigitale.NonEsiste,
        urlProcessoRiconoscimento: "",
        urlProcessoFirma: "",
        statoProcessoFirmaCqsOnline: CqsOnlineStatoProcessoDocumentiDaFirmare.DaAvviare,
        responseCheckPreventivo: false,
        msgCheckPreventivo: "",
        responseCancellaPreventivoRichiesta: false,
        msgCancellaPreventivoRichiesta: "",
        responseConcludi: false,
        altriPrestiti: [] as NuovoImpegnoModel[],
        responseTrasferisciConsensi: false,
    };

    public [RichiestaAction.VERIFICA_RICHIESTA_FINISHED](
        state: IRichiestaState,
        action: IAction<ResponseEsitoModel>
    ): IRichiestaState {
        let idRichiesta = 0;
        if (action.payload) {
            idRichiesta = parseInt(action.payload!.infoEsito);
            if (isNaN(idRichiesta) === true || idRichiesta <= 0) {
                idRichiesta = 0;
            }
        }
        return {
            ...state,
            isRichiestaPresente: action.payload!.esito,
            corrente: new RichiestaModel({
                ...state.corrente,
                idRichiesta: idRichiesta,
            }),
            responseVerificaRichiesta: true,
        };
    }

    public [RichiestaAction.REQUEST_RICHIESTA_FINISHED](
        state: IRichiestaState,
        action: IAction<RichiestaModel>
    ): IRichiestaState {
        return {
            ...state,
            corrente: action.payload! as RichiestaModel,
            responseRichiesta: true,
        };
    }

    public [RichiestaAction.SAVE_STEP_RICHIESTA_FINISHED](
        state: IRichiestaState,
        action: IAction<ResponseEsitoModel>
    ): IRichiestaState {
        return {
            ...state,
            responseStepRichiesta: action.payload!.esito,
        };
    }

    public [RichiestaAction.DOWNLOAD_PIANO_AMMORTAMENTO_FINISHED](
        state: IRichiestaState,
        action: IAction<Blob>
    ): IRichiestaState {
        return {
            ...state,
            responseDownloadPianoAmmortamento: action.payload instanceof Blob ? true : false,
        };
    }

    public [RichiestaAction.REQUEST_DATI_ANAGRAFICI_FINISHED](
        state: IRichiestaState,
        action: IAction<RichiestaDatiAnagraficiRequestModel>
    ): IRichiestaState {
        return {
            ...state,
            corrente: {
                ...state.corrente,
                datiAnagrafici: action.payload! as RichiestaDatiAnagraficiRequestModel,
            } as RichiestaModel,
        };
    }

    public [RichiestaAction.SAVE_DATI_ANAGRAFICI_FINISHED](
        state: IRichiestaState,
        action: IAction<ResponseEsitoModel>
    ): IRichiestaState {
        return {
            ...state,
            responseDatiAnagrafici: action.payload!.esito,
        };
    }

    public [RichiestaAction.REQUEST_DATI_REDDITO_FINISHED](
        state: IRichiestaState,
        action: IAction<RichiestaDatiRedditoRequestModel>
    ): IRichiestaState {
        return {
            ...state,
            corrente: {
                ...state.corrente,
                datiReddito: action.payload! as RichiestaDatiRedditoRequestModel,
            } as RichiestaModel,
        };
    }
    public [RichiestaAction.SAVE_DATI_REDDITO_FINISHED](
        state: IRichiestaState,
        action: IAction<ResponseEsitoModel>
    ): IRichiestaState {
        return {
            ...state,
            responseDatiReddito: action.payload!.esito,
        };
    }

    public [RichiestaAction.REQUEST_ALTRI_PRESTITI_FINISHED](
        state: IRichiestaState,
        action: IAction<RichiestaAltriPrestitiRequestModel>
    ): IRichiestaState {
        return {
            ...state,
            corrente: {
                ...state.corrente,
                altriPrestiti: action.payload! as RichiestaAltriPrestitiRequestModel,
            } as RichiestaModel,
        };
    }
    public [RichiestaAction.SAVE_ALTRI_PRESTITI_FINISHED](
        state: IRichiestaState,
        action: IAction<ResponseEsitoModel>
    ): IRichiestaState {
        return {
            ...state,
            responseAltriPrestiti: action.payload!.esito,
        };
    }

    public [RichiestaAction.REQUEST_DOCUMENTI_FIRMA_FORTE_FINISHED](
        state: IRichiestaState,
        action: IAction<RichiestaDocumentoViewModel[]>
    ): IRichiestaState {
        const result = action.payload! as RichiestaDocumentoViewModel[];
        const documentiDaFirmare = result.filter((x) => x.tipoDocumento.fgDaGenerare === true);
        return {
            ...state,
            corrente: {
                ...state.corrente,
                documentiFirmaForte: {
                    elenco: documentiDaFirmare,
                } as RichiestaDocumentiViewModel,
            } as RichiestaModel,
        };
    }

    public [RichiestaAction.UPLOAD_DOCUMENTO_FINISHED](
        state: IRichiestaState,
        action: IAction<ResponseEsitoModel>
    ): IRichiestaState {
        return {
            ...state,
            responseUploadDocumento: action.payload!.esito,
        };
    }

    public [RichiestaAction.REQUEST_AVVIA_PROCESSO_FIRMA_DEBOLE_FINISHED](
        state: IRichiestaState,
        action: IAction<ResponseEsitoModel>
    ): IRichiestaState {
        return {
            ...state,
            responseAvviaProcessoFirmaDebole: action.payload!.esito,
        };
    }

    public [RichiestaAction.REQUEST_ANNULLA_PROCESSO_FIRMA_DEBOLE_FINISHED](
        state: IRichiestaState,
        action: IAction<ResponseEsitoModel>
    ): IRichiestaState {
        return {
            ...state,
            responseAnnullaProcessoFirmaDebole: action.payload!.esito,
        };
    }

    public [RichiestaAction.REQUEST_STATO_PROCESSO_FIRMA_DEBOLE_FINISHED](
        state: IRichiestaState,
        action: IAction<ResponseStatoModel>
    ): IRichiestaState {
        let statoEnum = StatoProcessoFirmaDigitale.NonEsiste;
        const stato = action.payload!.stato;
        switch (stato) {
            case "NON_ESISTE":
                statoEnum = StatoProcessoFirmaDigitale.NonEsiste;
                break;
            case "IN_CORSO":
                statoEnum = StatoProcessoFirmaDigitale.InCorso;
                break;
            case "ANNULLATO":
                statoEnum = StatoProcessoFirmaDigitale.Annullato;
                break;
            case "COMPLETATO":
                statoEnum = StatoProcessoFirmaDigitale.Completato;
                break;
        }
        return {
            ...state,
            statoProcessoFirmaDebole: statoEnum,
        };
    }

    public [RichiestaAction.REQUEST_AVVIA_PROCESSO_FIRMA_FORTE_FINISHED](
        state: IRichiestaState,
        action: IAction<ResponseEsitoModel>
    ): IRichiestaState {
        return {
            ...state,
            responseAvviaProcessoFirmaForte: action.payload!.esito,
        };
    }

    public [RichiestaAction.REQUEST_ANNULLA_PROCESSO_FIRMA_FORTE_FINISHED](
        state: IRichiestaState,
        action: IAction<ResponseEsitoModel>
    ): IRichiestaState {
        return {
            ...state,
            responseAnnullaProcessoFirmaForte: action.payload!.esito,
        };
    }

    public [RichiestaAction.REQUEST_STATO_PROCESSO_FIRMA_FORTE_FINISHED](
        state: IRichiestaState,
        action: IAction<ResponseStatoModel>
    ): IRichiestaState {
        let statoEnum = StatoProcessoFirmaDigitale.NonEsiste;
        const stato = action.payload!.stato;
        switch (stato) {
            case "NON_ESISTE":
                statoEnum = StatoProcessoFirmaDigitale.NonEsiste;
                break;
            case "IN_CORSO":
                statoEnum = StatoProcessoFirmaDigitale.InCorso;
                break;
            case "ANNULLATO":
                statoEnum = StatoProcessoFirmaDigitale.Annullato;
                break;
            case "COMPLETATO":
                statoEnum = StatoProcessoFirmaDigitale.Completato;
                break;
        }
        return {
            ...state,
            statoProcessoFirmaForte: statoEnum,
            urlProcessoFirma: action.payload?.infoStato ?? "",
        };
    }

    public [RichiestaAction.REQUEST_AVVIA_PROCESSO_RICONOSCIMENTO_FINISHED](
        state: IRichiestaState,
        action: IAction<ResponseEsitoModel>
    ): IRichiestaState {
        return {
            ...state,
            responseAvviaProcessoRiconoscimento: action.payload!.esito,
        };
    }

    /*  public [RichiestaAction.REQUEST_ANNULLA_PROCESSO_RICONOSCIMENTO_FINISHED](
        state: IRichiestaState,
        action: IAction<ResponseEsitoModel>
    ): IRichiestaState {
        return {
            ...state,
            responseAnnullaProcessoRiconoscimento: action.payload!.esito,
        };
    }
 */
    /*  public [RichiestaAction.REQUEST_STATO_PROCESSO_RICONOSCIMENTO_FINISHED](
        state: IRichiestaState,
        action: IAction<ResponseStatoModel>
    ): IRichiestaState {
        let statoEnum = StatoProcessoFirmaDigitale.NonEsiste;
        const stato = action.payload!.stato;
        switch (stato) {
            case "NON_ESISTE":
                statoEnum = StatoProcessoFirmaDigitale.NonEsiste;
                break;
            case "IN_CORSO":
                statoEnum = StatoProcessoFirmaDigitale.InCorso;
                break;
            case "ANNULLATO":
                statoEnum = StatoProcessoFirmaDigitale.Annullato;
                break;
            case "COMPLETATO":
                statoEnum = StatoProcessoFirmaDigitale.Completato;
                break;
        }
        return {
            ...state,
            statoProcessoRiconoscimento: statoEnum,
            urlProcessoRiconoscimento: action.payload!.infoStato,
        };
    } */
    // #region CQS online
    public [RichiestaAction.REQUEST_DOCUMENTI_DA_CARICARE_CQSOL_FINISHED](
        state: IRichiestaState,
        action: IAction<CqsOnlineRichiestaSezioneDocumentiViewModel[]>
    ): IRichiestaState {
        return {
            ...state,
            corrente: {
                ...state.corrente,
                documentiDaCaricare: action.payload!,
            } as RichiestaModel,
        };
    }

    public [RichiestaAction.REQUEST_DOCUMENTI_DA_FIRMARE_CQSOL_FINISHED](
        state: IRichiestaState,
        action: IAction<CqsOnlineRichiestaSezioneDocumentiViewModel[]>
    ): IRichiestaState {
        return {
            ...state,
            corrente: {
                ...state.corrente,
                documentiDaFirmare: action.payload!.map((sezione) => {
                    return new CqsOnlineRichiestaSezioneDocumentiViewModel({
                        ...sezione,
                        infoSezione: new CqsOnlineRichiestaInfoSezionePreventivoViewModel({
                            ...sezione.infoSezione,
                        }),
                    });
                }),
            } as RichiestaModel,
        };
    }

    public [RichiestaAction.UPLOAD_DOCUMENTO_CQSOL_FINISHED](
        state: IRichiestaState,
        action: IAction<ResponseEsitoModel>
    ): IRichiestaState {
        const filePath = action.payload!.infoEsito;
        const partFileName = filePath.split(".")[0].split("-");
        const fileName = partFileName[2];
        return {
            ...state,
            responseUploadDocumento: action.payload!.esito,
            corrente: {
                ...state.corrente,
                documentiDaCaricare: state.corrente.documentiDaCaricare?.map((sez) => {
                    return new CqsOnlineRichiestaSezioneDocumentiViewModel({
                        ...sez,
                        documenti: sez.documenti?.map((doc) => {
                            if ((doc.idDocConfigCqsOL?.toString() ?? "") + doc.tipoDocumento.toString() === fileName) {
                                return new CqsOnlineRichiestaDettaglioDocumentoViewModel({
                                    ...doc,
                                    path: filePath,
                                });
                            }
                            return doc;
                        }),
                    });
                }),
            } as RichiestaModel,
        };
    }

    public [RichiestaAction.SAVE_SEZIONE_DOCUMENTI_CQSOL_FINISHED](
        state: IRichiestaState,
        action: IAction<ResponseEsitoModel>
    ): IRichiestaState {
        return {
            ...state,
        };
    }

    public [RichiestaAction.DOWNLOAD_DOCUMENTO_CQSOL_FINISHED](
        state: IRichiestaState,
        action: IAction<Blob>
    ): IRichiestaState {
        return {
            ...state,
            responseDownloadDocumento: action.payload instanceof Blob ? true : false,
        };
    }

    public [RichiestaAction.DELETE_DOCUMENTO_CQSOL_FINISHED](
        state: IRichiestaState,
        action: IAction<ResponseEsitoModel>
    ): IRichiestaState {
        return {
            ...state,
            corrente: {
                ...state.corrente,
                documentiDaCaricare: state.corrente.documentiDaCaricare?.map((s) => {
                    return {
                        ...s,
                        documenti: s.documenti?.map((d) => {
                            if (d.idDoc === Number(action.payload?.infoEsito)) {
                                let result = new CqsOnlineRichiestaDettaglioDocumentoViewModel({
                                    ...d,
                                    idDoc: 0,
                                    chiaveDoc: "",
                                    contentType: "",
                                    base64File: "",
                                    uploadCompleto: false,
                                });
                                return result;
                            } else {
                                return d;
                            }
                        }),
                    } as CqsOnlineRichiestaSezioneDocumentiViewModel;
                }),
            } as RichiestaModel,
        };
    }

    public [RichiestaAction.REQUEST_AVVIA_PROCESSO_FIRMA_CQSOL_FINISHED](
        state: IRichiestaState,
        action: IAction<ResponseEsitoModel>
    ): IRichiestaState {
        return {
            ...state,
            responseAvviaProcessoFirmaDebole: action.payload!.esito,
            urlProcessoFirma: action.payload!.infoEsito,
        };
    }

    public [RichiestaAction.REQUEST_ANNULLA_PROCESSO_FIRMA_CQSOL_FINISHED](
        state: IRichiestaState,
        action: IAction<ResponseEsitoModel>
    ): IRichiestaState {
        return {
            ...state,
            responseAnnullaProcessoFirmaDebole: action.payload!.esito,
            urlProcessoFirma: action.payload!.infoEsito,
        };
    }
    public [RichiestaAction.REQUEST_STATO_FIRMA_CQSOL_FINISHED](
        state: IRichiestaState,
        action: IAction<ResponseStatoModel>
    ): IRichiestaState {
        let statoEnum = CqsOnlineStatoProcessoDocumentiDaFirmare.DaAvviare;
        const stato = action.payload!.stato;
        switch (stato) {
            case "NON_ESISTE":
                statoEnum = CqsOnlineStatoProcessoDocumentiDaFirmare.DaAvviare;
                break;
            case "IN_CORSO":
                statoEnum = CqsOnlineStatoProcessoDocumentiDaFirmare.InCorso;
                break;
            case "COMPLETATO":
                statoEnum = CqsOnlineStatoProcessoDocumentiDaFirmare.Completato;
                break;
        }
        return {
            ...state,
            statoProcessoFirmaCqsOnline: statoEnum,
        };
    }

    public [RichiestaAction.REQUEST_AVVIA_PROCESSO_RICONOSCIMENTO_CQSOL_FINISHED](
        state: IRichiestaState,
        action: IAction<ResponseEsitoModel>
    ): IRichiestaState {
        return {
            ...state,
            responseAvviaProcessoRiconoscimento: action.payload!.esito,
            urlProcessoRiconoscimento: action.payload!.infoEsito,
        };
    }

    public [RichiestaAction.REQUEST_ANNULLA_PROCESSO_RICONOSCIMENTO_CQSOL_FINISHED](
        state: IRichiestaState,
        action: IAction<ResponseEsitoModel>
    ): IRichiestaState {
        return {
            ...state,
            responseAnnullaProcessoRiconoscimento: action.payload!.esito,
        };
    }

    public [RichiestaAction.REQUEST_STATO_PROCESSO_RICONOSCIMENTO_CQSOL_FINISHED](
        state: IRichiestaState,
        action: IAction<ResponseStatoModel>
    ): IRichiestaState {
        let statoEnum = StatoProcessoFirmaDigitale.NonEsiste;
        const stato = action.payload!.stato;
        switch (stato) {
            case "NON_ESISTE":
                statoEnum = StatoProcessoFirmaDigitale.NonEsiste;
                break;
            case "IN_CORSO":
                statoEnum = StatoProcessoFirmaDigitale.InCorso;
                break;
            case "ANNULLATO":
                statoEnum = StatoProcessoFirmaDigitale.Annullato;
                break;
            case "COMPLETATO":
                statoEnum = StatoProcessoFirmaDigitale.Completato;
                break;
        }
        return {
            ...state,
            statoProcessoRiconoscimento: statoEnum,
            urlProcessoRiconoscimento: action.payload!.infoStato,
        };
    }

    public [RichiestaAction.REQUEST_CHECK_PREVENTIVO_CQSOL_FINISHED](
        state: IRichiestaState,
        action: IAction<ResponseEsitoModel>
    ): IRichiestaState {
        return {
            ...state,
            responseCheckPreventivo: action.payload!.esito,
            msgCheckPreventivo: action.payload!.infoEsito,
        };
    }

    public [RichiestaAction.REQUEST_CANCELLA_PREVENTIVO_RICHIESTA_CQSOL_FINISHED](
        state: IRichiestaState,
        action: IAction<ResponseEsitoModel>
    ): IRichiestaState {
        return {
            ...state,
            responseCancellaPreventivoRichiesta: action.payload!.esito,
            msgCancellaPreventivoRichiesta: action.payload!.infoEsito,
        };
    }

    public [RichiestaAction.REQUEST_DOCUMENTI_ISTRUTTORIA_DA_FIRMARE_CQSOL_FINISHED](
        state: IRichiestaState,
        action: IAction<CqsOnlineRichiestaSezioneDocumentiViewModel[]>
    ): IRichiestaState {
        return {
            ...state,
            corrente: {
                ...state.corrente,
                documentiDaFirmareIstruttoria: action.payload!,
            } as RichiestaModel,
        };
    }

    public [RichiestaAction.REQUEST_CONCLUDI_DICHIARAZIONI_CQSOL_FINISHED](
        state: IRichiestaState,
        action: IAction<RichiestaConcludiRequestModel>
    ): IRichiestaState {
        return {
            ...state,
            corrente: {
                ...state.corrente,
                concludi: action.payload!,
            } as RichiestaModel,
        };
    }

    public [RichiestaAction.SAVE_CONCLUDI_DICHIARAZIONI_CQSOL_FINISHED](
        state: IRichiestaState,
        action: IAction<ResponseEsitoModel>
    ): IRichiestaState {
        return {
            ...state,
            responseConcludi: action.payload!.esito,
        };
    }

    public [RichiestaAction.REQUEST_IMPEGNI_CQSOL_FINISHED](
        state: IRichiestaState,
        action: IAction<NuovoImpegnoModel[]>
    ): IRichiestaState {
        return {
            ...state,
            altriPrestiti: action.payload!.map((imp) => {
                return {
                    ...imp,
                    fgPresenzaDati: imp.rata > 0 ? "S" : "N",
                };
            }) as NuovoImpegnoModel[],
        };
    }

    public [RichiestaAction.SAVE_IMPEGNI_FINISHED](
        state: IRichiestaState,
        action: IAction<ResponseEsitoModel>
    ): IRichiestaState {
        //  console.log("Reducer " , state);
        return {
            ...state,
            responseAltriPrestiti: action.payload!.esito,
        };
    }

    public [RichiestaAction.REQUEST_ADEGUATA_VERIFICA_FINISHED](
        state: IRichiestaState,
        action: IAction<RichiestaAdeguataVerificaRequestModel>
    ): IRichiestaState {
        return {
            ...state,
            corrente: {
                ...state.corrente,
                adeguataVerifica: action.payload! as RichiestaAdeguataVerificaRequestModel,
            } as RichiestaModel,
        };
    }

    public [RichiestaAction.REQUEST_SAVE_ADEGUATA_VERIFICA_FINISHED](
        state: IRichiestaState,
        action: IAction<ResponseEsitoModel>
    ): IRichiestaState {
        return {
            ...state,
            responseAdeguataVerifica: action.payload!.esito ?? true,
        };
    }
    public [RichiestaAction.DELETE_IMPEGNI_FINISHED](
        state: IRichiestaState,
        action: IAction<ResponseEsitoModel>
    ): IRichiestaState {
        return {
            ...state,
            responseAltriPrestiti: action.payload!.esito,
        };
    }

    public [RichiestaAction.TRASFERISCI_DOC_CONSENSI_CQSWEB_FINISHED](
        state: IRichiestaState,
        action: IAction<ResponseEsitoModel>
    ): IRichiestaState {
        return {
            ...state,
            responseTrasferisciConsensi: action.payload!.esito,
        };
    }

    // #endregion CQS online

    //metodi non necessari
    // public [RichiestaAction.DOWNLOAD_DOCUMENTO_FINISHED](
    //     state: IRichiestaState,
    //     action: IAction<Blob>
    // ): IRichiestaState {
    //     return {
    //         ...state,
    //         responseDownloadDocumento: action.payload instanceof Blob ? true : false,
    //     };
    // }

    // public [RichiestaAction.DELETE_DOCUMENTO_FINISHED](
    //     state: IRichiestaState,
    //     action: IAction<ResponseEsitoModel>
    // ): IRichiestaState {
    //     return {
    //         ...state,
    //         corrente: {
    //             ...state.corrente,
    //             documentiDaCaricare: {
    //                 elenco: state.corrente.documentiDaCaricare?.elenco?.map((d) => {
    //                     if (d.idDocumento === Number(action.payload?.infoEsito)) {
    //                         let result = new RichiestaDocumentoViewModel({
    //                             tipoDocumento: new RichiestaTipoDocumentoViewModel({ ...d.tipoDocumento }),
    //                         });
    //                         return result;
    //                     } else {
    //                         return d;
    //                     }
    //                 }),
    //             } as RichiestaDocumentiViewModel,
    //         } as RichiestaModel,
    //     };
    // }
}
